import { Box, Paper, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowRight } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { Link } from "@/components";
import type { AuthFormLayoutProps } from "./AuthFormLayout.types";
import * as styles from "./AuthFormLayout.styles";

export type { AuthFormLayoutProps } from "./AuthFormLayout.types";

export function AuthFormLayout({
  children,
  title,
  subtitle,
  showLogo = true,
  headerIcon,
  headerSpacing = "default",
  backTo,
  backLabel,
}: AuthFormLayoutProps) {
  const theme = useTheme();
  const { t } = useTranslation("auth");

  return (
    <Stack sx={styles.root}>
      <Box
        component="img"
        src="/images/auth-bg.jpg"
        alt=""
        width={1920}
        height={1047}
        decoding="async"
        sx={styles.backgroundImage}
      />
      <Box sx={styles.overlay(theme)} />
      <Box sx={styles.container}>
        <Paper elevation={0} sx={styles.paper(theme)}>
          {backTo ? (
            <Link to={backTo}>
              <Stack sx={styles.backLink}>
                <ArrowRight size={18} variant="Linear" color={theme.palette.text.secondary} />
                <Typography variant="body2" fontWeight={500}>
                  {backLabel ?? t("back")}
                </Typography>
              </Stack>
            </Link>
          ) : null}

          {title || showLogo || headerIcon ? (
            <Stack sx={styles.header(headerSpacing)}>
              {headerIcon ? (
                <Stack sx={styles.headerIconWrap(theme)}>{headerIcon}</Stack>
              ) : showLogo ? (
                <Box component="img" src="/images/logo.png" alt="SEFANO" sx={styles.logo} />
              ) : null}

              {title ? (
                <Stack sx={styles.titleBlock}>
                  <Typography sx={styles.title}>{title}</Typography>
                  {subtitle ? (
                    typeof subtitle === "string" ? (
                      <Typography sx={styles.subtitle(headerSpacing)}>{subtitle}</Typography>
                    ) : (
                      <Box sx={styles.subtitle(headerSpacing)}>{subtitle}</Box>
                    )
                  ) : null}
                </Stack>
              ) : null}
            </Stack>
          ) : null}

          {children}
        </Paper>
      </Box>

      <Typography sx={styles.copyright(theme)}>{t("copyright")}</Typography>
    </Stack>
  );
}
